module.exports = __webpack_public_path__ + "img/ca.e8d9c5ac.png";